import { StoreInjectConfig } from '@mihanizm56/redux-core-modules';
import i18next from 'i18next';
import { userDataSelector } from '@wildberries/databus-service-user';
import { selectedSupplierIdSelector } from '@wildberries/databus-service-suppliers';
import warehousesLimitsReducer, {
  setCoefficientsReportAction,
  setStartWarehousesLoadingAction,
  setStopWarehousesLoadingAction,
  WAREHOUSES_LIMITS_REDUCER_NAME,
  setCostForPaletteAction,
} from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module';
import { WAREHOUSES_LIMITS_PAGE_TRANSLATIONS } from '@/pages/supplies-management/children/warehouses-limits/_constants/translations';
import { getAcceptanceCoefficientsRequestReport } from '@/api/requests/get-acceptance-coefficients-report';
import { WAREHOUSES_LIMITS_UP_TO_DAY } from '@/pages/supplies-management/children/warehouses-limits/page/_components/connected-warehouses-limits/_constants';
import { addCalendarDays } from '@/pages/supplies-management/_utils/add-days';
import { getMonopaletteInfoRequest } from '@/api/requests/get-monopalette-info';
import { getFormatterCoefficient } from './_utils/get-formatter-coefficient';

export const storeInjectConfig = (): StoreInjectConfig => {
  const dateFrom = new Date();
  const dateTo = new Date(
    dateFrom.getFullYear(),
    dateFrom.getMonth(),
    dateFrom.getDate() + WAREHOUSES_LIMITS_UP_TO_DAY,
  );
  const dateToFormat = addCalendarDays({
    amount: dateTo,
    step: 'day',
    days: 1,
  });

  const supplierID = selectedSupplierIdSelector();
  const { id: userID } = userDataSelector();

  return {
    reducersToInject: [
      {
        name: WAREHOUSES_LIMITS_REDUCER_NAME,
        reducer: warehousesLimitsReducer,
      },
    ],
    initialLoadManagerConfig: {
      requestConfigList: [
        {
          request: getAcceptanceCoefficientsRequestReport,
          requestOptions: {
            dateFrom,
            dateTo: dateToFormat,
            supplierID,
            userID,
          },
          showErrorNotification: true,
          loadingStartAction: setStartWarehousesLoadingAction,
          loadingStopAction: setStopWarehousesLoadingAction,
          responseDataFormatter: getFormatterCoefficient,
          actionSuccess: setCoefficientsReportAction,
          titleMessageError: i18next.t(
            WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.warehousesFetchError,
          ),
        },
        {
          request: getMonopaletteInfoRequest,
          showErrorNotification: true,
          loadingStartAction: setStartWarehousesLoadingAction,
          loadingStopAction: setStopWarehousesLoadingAction,
          responseDataFormatter: (response) => response?.info?.cost,
          actionSuccess: setCostForPaletteAction,
          titleMessageError: i18next.t(
            WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.warehousesFetchError,
          ),
        },
      ],
    },
  };
};
